import { $ } from "./EventModal.utils.js";
import { buildGoogleMapsUrl } from "../../utils/locationUtils.js";

function setMapsTarget(el, url) {
  if (!el) return;
  el.classList.toggle("cursor-pointer", Boolean(url));
  el.classList.toggle("hover:text-blue-700", Boolean(url));
  el.setAttribute("title", url ? "Abrir ubicacion en Google Maps" : "");
  el.setAttribute("tabindex", url ? "0" : "-1");
  el.onclick = url ? () => window.open(url, "_blank", "noopener") : null;
  el.onkeydown = url ? (ev) => {
    if (ev.key === "Enter" || ev.key === " ") {
      ev.preventDefault();
      window.open(url, "_blank", "noopener");
    }
  } : null;
}

export function setContactPreview(root, contact) {
  const name = $(root, "#event-contact-preview-name");
  const email = $(root, "#event-contact-preview-email");
  const phone = $(root, "#event-contact-preview-phone");

  if (!contact) {
    name && (name.textContent = "\u2014");
    email && (email.textContent = "\u2014");
    phone && (phone.textContent = "\u2014");
    return;
  }

  const fullName = [contact.name, contact.surname].filter(Boolean).join(" ").trim() || "\u2014";
  name && (name.textContent = fullName);
  email && (email.textContent = contact.email || "\u2014");
  phone && (phone.textContent = contact.phone || "\u2014");
}

export function setVenuePreview(root, venue) {
  const name = $(root, "#event-venue-preview-name");
  const address = $(root, "#event-venue-preview-address");
  const region = $(root, "#event-venue-preview-region");
  const mapLink = $(root, "#event-venue-map-link");

  if (!venue) {
    name && (name.textContent = "\u2014");
    address && (address.textContent = "\u2014");
    region && (region.textContent = "\u2014");
    [name, address, region].forEach(el => setMapsTarget(el, ""));
    if (mapLink) {
      mapLink.href = "#";
      mapLink.classList.add("hidden");
    }
    return;
  }

  name && (name.textContent = venue.name || "\u2014");
  address && (address.textContent = venue.address || "\u2014");

  const reg = [venue.city, venue.region].filter(Boolean).join(" \u00b7 ").trim() || "\u2014";
  region && (region.textContent = reg);

  const mapsUrl = buildGoogleMapsUrl([venue.name, venue.address, venue.city, venue.region, "Espa\u00f1a"]);
  [name, address, region].forEach(el => setMapsTarget(el, mapsUrl));

  if (mapLink) {
    mapLink.href = mapsUrl || "#";
    mapLink.classList.remove("hidden");
  }
}

/**
 * Renderiza el bloque de distancia/precio por km del venue seleccionado.
 * @param {HTMLElement} root
 * @param {null | { loading: true } | { km: number, priceLabel?: string }} payload
 */
export function setVenueDistancePreview(root, payload) {
  const box = $(root, "#event-venue-distance");
  if (!box) return;

  if (!payload) {
    box.classList.add("hidden");
    box.innerHTML = "";
    return;
  }

  box.classList.remove("hidden");

  if (payload.loading) {
    box.innerHTML = '<i class="fa-solid fa-spinner fa-spin mr-1"></i>Calculando distancia...';
    return;
  }

  const kmLabel = Number(payload.km).toLocaleString("es-ES", { maximumFractionDigits: 1 });
  const priceHtml = payload.priceLabel ? ` &middot; ${payload.priceLabel}` : "";
  box.innerHTML = `<i class="fa-solid fa-route mr-1"></i>Distancia: ${kmLabel} km desde salida${priceHtml}`;
}

/**
 * Pinta el estado (on/off) del switch "Incluye equipo". No es un
 * &lt;input type="checkbox"&gt;: es un &lt;button&gt; que controlamos
 * nosotros mismos via data-checked, para evitar el problema reportado
 * con checkboxes nativos en esta app.
 * @param {HTMLElement} root
 * @param {boolean} checked
 */
export function setEquipmentToggle(root, checked) {
  const btn = $(root, "#event-equipment-included");
  const dot = $(root, "#event-equipment-included-dot");
  if (!btn) return;

  const isOn = Boolean(checked);
  btn.dataset.checked = isOn ? "true" : "false";
  btn.setAttribute("aria-checked", isOn ? "true" : "false");
  btn.classList.toggle("bg-blue-600", isOn);
  btn.classList.toggle("bg-slate-300", !isOn);
  if (dot) dot.classList.toggle("translate-x-5", isOn);
  if (dot) dot.classList.toggle("translate-x-1", !isOn);
}

/**
 * Lee el estado actual del switch "Incluye equipo".
 * @param {HTMLElement} root
 * @returns {boolean}
 */
export function getEquipmentToggle(root) {
  return $(root, "#event-equipment-included")?.dataset.checked === "true";
}
